import React from "react";
import styles from "./tooltip.module.css";

export function SideNavTooltip(props) {
  <div className=" mr-3">
    <div className={styles.tooltip}>
      {/* Hover over me */}
      <span>
        <i class="fa fa-info-circle text-blue-800" aria-hidden="true"></i>
      </span>
      <span className={`${styles.tooltiptext} w-64 bg-blue-400 text-white`}>
        {props.text}
      </span>
    </div>
  </div>;
}
export default function Tooltip(props) {
  return (
    <div className="text-end mr-0 ml-1">
      <div className={styles.tooltip}>
        {/* Hover over me */}
        <span>
          <i class="fa fa-info-circle text-blue-800" aria-hidden="true"></i>
        </span>
        <span
          className={`${styles.tooltiptext} w-52 bg-blue-400 text-white`}
        >
          {props.text}
        </span>
      </div>
    </div>
  );
}
